var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.getList, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", width: "50", label: "ID" },
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "type", label: "类别" },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              width: "110",
              prop: "name",
              label: "会员类型名称",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "overflow-ellipsis",
                        attrs: { slot: "reference" },
                        slot: "reference",
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "level", label: "会员等级" },
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "weightLevel", label: "权重等级" },
          }),
          _c("el-table-column", {
            attrs: { width: "100", prop: "icon", label: "会员图标" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.icon
                      ? _c("el-image", {
                          attrs: { src: scope.row.icon, fit: "scale - down" },
                        })
                      : _c("span", [_vm._v("未上传会员图标")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              width: "120",
              prop: "description",
              label: "会员描述",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.description
                      ? _c("span", [_vm._v("暂无描述")])
                      : _c(
                          "span",
                          {
                            staticClass: "overflow-ellipsis",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [_vm._v(_vm._s(scope.row.description))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "110",
              prop: "publishPrice",
              label: "单日刊例价格",
            },
          }),
          _c("el-table-column", {
            attrs: { width: "120", prop: "clientTypes", label: "客户端类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.clientTypes.split(","),
                    function (item) {
                      return _c(
                        "el-tag",
                        {
                          key: item,
                          staticStyle: {
                            "margin-right": "5px",
                            "margin-bottom": "5px",
                          },
                          attrs: { size: "small" },
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "150", prop: "rightsItemsDesc", label: "权益项集" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.rightsItemsDesc.split(","),
                    function (item) {
                      return _c(
                        "el-tag",
                        {
                          key: item,
                          staticStyle: {
                            "margin-right": "5px",
                            "margin-bottom": "5px",
                          },
                          attrs: { size: "small" },
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "memberIdentity", label: "用户身份" },
          }),
          _c("el-table-column", {
            attrs: { width: "50", prop: "state", label: "状态" },
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "sellStatus", label: "售卖状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n      " +
                        _vm._s(scope.row.sellStatus === 1 ? "在售" : "停售") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.getCurrentTab === "localData"
            ? _c("el-table-column", {
                attrs: { width: "80", prop: "reviewStatus", label: "审核状态" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              width: "100",
              prop: "remark",
              label: "备注",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.remark
                      ? _c("span", [_vm._v("暂无备注")])
                      : _c(
                          "div",
                          {
                            staticClass: "overflow-ellipsis",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [_vm._v(_vm._s(scope.row.remark))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm.getCurrentTab === "localData"
            ? _c("el-table-column", {
                attrs: { width: "130", fixed: "right", label: "操作" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "MEMBER_TYPE_MANAGE_LOG",
                                  expression: "'MEMBER_TYPE_MANAGE_LOG'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.checkLog(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("查看日志")]
                          ),
                          scope.row.reviewStatus !== "待审核"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_TYPE_MANAGE_EDIT",
                                      expression: "'MEMBER_TYPE_MANAGE_EDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus === "草稿"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_TYPE_MANAGE_FOR_AUDIT",
                                      expression:
                                        "'MEMBER_TYPE_MANAGE_FOR_AUDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSubmitAudit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("提交审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus === "待审核"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_TYPE_MANAGE_CANCEL_AUDIT",
                                      expression:
                                        "'MEMBER_TYPE_MANAGE_CANCEL_AUDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCancelAudit(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("撤销审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus !== "待审核"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_TYPE_MANAGE_DEL",
                                      expression: "'MEMBER_TYPE_MANAGE_DEL'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDel(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1927420419
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("AddDialog", {
        attrs: {
          addDialog: _vm.editDialog,
          title: "编辑会员类型",
          addFrom: _vm.addFrom,
          TableClientSelect: _vm.clientSelect,
          memberTypeRightsItems: _vm.memberTypeRightsItems,
        },
        on: {
          "update:addDialog": function ($event) {
            _vm.editDialog = $event
          },
          "update:add-dialog": function ($event) {
            _vm.editDialog = $event
          },
          "update:TableClientSelect": function ($event) {
            _vm.clientSelect = $event
          },
          "update:table-client-select": function ($event) {
            _vm.clientSelect = $event
          },
          "update:memberTypeRightsItems": function ($event) {
            _vm.memberTypeRightsItems = $event
          },
          "update:member-type-rights-items": function ($event) {
            _vm.memberTypeRightsItems = $event
          },
          updateData: _vm.updateData,
        },
      }),
      _c("logDialog", {
        attrs: { logDialog: _vm.logDialog, id: _vm.logId, source: _vm.source },
        on: {
          "update:logDialog": function ($event) {
            _vm.logDialog = $event
          },
          "update:log-dialog": function ($event) {
            _vm.logDialog = $event
          },
          "update:id": function ($event) {
            _vm.logId = $event
          },
          "update:source": function ($event) {
            _vm.source = $event
          },
        },
      }),
      _c("AuditDialog", {
        attrs: {
          auditDialog: _vm.auditDialog,
          afterUpdate: _vm.afterUpdate,
          beforeUpdate: _vm.beforeUpdate,
          showAuditOpinion: _vm.showAuditOpinion,
        },
        on: {
          "update:auditDialog": function ($event) {
            _vm.auditDialog = $event
          },
          "update:audit-dialog": function ($event) {
            _vm.auditDialog = $event
          },
          "update:afterUpdate": function ($event) {
            _vm.afterUpdate = $event
          },
          "update:after-update": function ($event) {
            _vm.afterUpdate = $event
          },
          "update:beforeUpdate": function ($event) {
            _vm.beforeUpdate = $event
          },
          "update:before-update": function ($event) {
            _vm.beforeUpdate = $event
          },
          "update:showAuditOpinion": function ($event) {
            _vm.showAuditOpinion = $event
          },
          "update:show-audit-opinion": function ($event) {
            _vm.showAuditOpinion = $event
          },
          updateData: _vm.updateData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }